import { Typography } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import { GROUP } from './constants';
import { Root } from './styles';
import { type GroupProps } from './types';

export const Group: FC<PropsWithChildren<GroupProps>> = ({ children, header }) => {
  const { getTestId } = useTestId();

  return (
    <Root data-testid={getTestId(GROUP)}>
      <Typography
        fontWeight="bold"
        color="textPrimary"
        textTransform="uppercase"
      >
        {header}
      </Typography>
      {children}
    </Root>
  );
};
